import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRetakeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24 44C35 44 44 35 44 24C44 13 35 4 24 4C13 4 4 13 4 24C4 35 13 44 24 44Z",
			fill: "white",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8901 17.0784C26.0201 16.8184 25.0601 16.6484 24.0001 16.6484C19.2101 16.6484 15.3301 20.5284 15.3301 25.3184C15.3301 30.1184 19.2101 33.9984 24.0001 33.9984C28.7901 33.9984 32.6701 30.1184 32.6701 25.3284C32.6701 23.5484 32.1301 21.8884 31.2101 20.5084",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.1302 17.32L25.2402 14",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.1298 17.3203L24.7598 19.7803",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRetakeIcon;
